import React, { useState, useEffect } from "react";
import "./ContactUs.css";

const ContactUs = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // --- email & phone validation helpers ---
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const onlyDigits = /^[0-9]*$/;

  const computeErrors = (email, phoneNumber) => {
    // only for primary contact
    if (email && !emailRegex.test(email)) {
      alert("Invalid email address");
      return true;
    }
    if (phoneNumber && !onlyDigits.test(phoneNumber)) {
      alert("Only numbers allowed in phone number");
      return true;
    } else if (
      phoneNumber &&
      (phoneNumber.length < 10 || phoneNumber.length > 11)
    ) {
      alert("Phone number must be 10–11 digits");
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
      email: email,
      message: message,
      guest: true, // Determine if the sender is a guest
    };
    try {
      if (computeErrors(email, phoneNumber)) return;
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/messages/message-send/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit the message.");
      }

      setSubmissionStatus("Message sent successfully!");
      setMessage(""); // Clear the message field after successful submission
    } catch (error) {
      setSubmissionStatus("Failed to send the message. Please try again.");
    }
  };

  return (
    <div className="contact-container flex flex-col md:flex-row">
      <div className="contact-info">
        <h2>Get in touch</h2>
        <p>
          We're here to help! Whether you have questions, need assistance, or
          want to provide feedback, feel free to reach out to us. You can
          contact us directly or leave an inquiry using the form below.
        </p>
        <div className="hidden md:block">
          <div className="contact-details">
            <div className="phone">
              <h3 className="phone">Contact</h3>
              <p className="phone">
                Phone:&nbsp;&nbsp;&nbsp;&nbsp;+1 905-749-9990
              </p>
              <p className="phone">
                Fax:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1
                905-749-9001
              </p>
            </div>

            <div className="email">
              <h3>Email</h3>
              <p>thompsonsquarepharmacy@gmail.com</p>
            </div>
            <div className="address">
              <h3>Address</h3>
              <p>9137 Derry Rd W #1, Milton, ON L9T 7Z1, Canada</p>
            </div>
          </div>
        </div>
      </div>
      <div className="inquiry-form">
        <form onSubmit={handleSubmit}>
          {
            <>
              <h2>Leave an Inquiry</h2>
              <div className="form-group">
                <label htmlFor="first-name">First Name</label>
                <input
                  type="text"
                  id="first-name"
                  placeholder="Your First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="px-3 py-1 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="last-name">Last Name</label>
                <input
                  type="text"
                  id="last-name"
                  placeholder="Your Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="px-3 py-1 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="px-3 py-1 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="Your Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="px-3 py-1 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  rows="4"
                  placeholder="Your Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                ></textarea>
              </div>
            </>
          }
          <button className="contact-button self-end" type="submit">
            Submit
          </button>
        </form>

        {submissionStatus && (
          <p className="submission-status">{submissionStatus}</p>
        )}
      </div>
      <div className="md:hidden">
        <div className="contact-details">
          <div className="phone">
            <h3 className="phone">Contact</h3>
            <p className="phone">
              Phone:&nbsp;&nbsp;&nbsp;&nbsp;+1 905-749-9990
            </p>
            <p className="phone">
              Fax:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1
              905-749-9001
            </p>
          </div>

          <div className="email">
            <h3>Email</h3>
            <p>thompsonsquarepharmacy@gmail.com</p>
          </div>
          <div className="address">
            <h3>Address</h3>
            <p>9137 Derry Rd W #1, Milton, ON L9T 7Z1, Canada</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
